import { render, staticRenderFns } from "./ProductCost4.vue?vue&type=template&id=3cb38e35&scoped=true"
import script from "./ProductCost4.vue?vue&type=script&lang=js"
export * from "./ProductCost4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb38e35",
  null
  
)

export default component.exports